import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";

export const FileUploaderStyles: {[key: string]: InterpolationWithTheme<any>} = {
    container: {
        width: "100%",
        marginBottom: "30px"
    },
    input: {
        opacity: 0,
        width: "100%",
        height: "100%",
        cursor: "pointer"
    },
    uploadContainer: {
        width: "150px",
        height: "150px",
        margin: "0 auto",
        border: "1px dashed crimson",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "-5px 5px 30px rgba(0, 0, 0, 0.2)",
        cursor: "pointer"
    },
    iconContainer: {
        position: "absolute"
    },
    img: {
        width: "60px"
    }
}